var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-primary-light py-20",attrs:{"id":"contact"}},[_c('div',{staticClass:"container mx-auto flex flex-row flex-wrap"},[_c('contact-text',{staticClass:"flex-1"}),_c('contact-form')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }